'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _f3tch = require('f3tch');

var _f3tch2 = _interopRequireDefault(_f3tch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (driverID, alertID) {
  var jwt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var api = (0, _f3tch2.default)('/drivers/' + driverID + '/alerts/' + alertID + '/').profile('no-data');
  if (!!jwt) api.headers({
    Authorization: 'JWT ' + jwt
  });
  return api.delete();
};